/**
 * Valid if it parses as a URL. Supports:
 * - http:// and https://
 * - www.example.com (prepends https:// to parse)
 * - bare domain like change.org (requires valid domain name + TLD)
 */
export const isValidEndorsementUrl = (url: string | undefined): boolean => {
	const trimmedUrl = typeof url === 'string' ? url.trim() : '';
	if (!trimmedUrl) return false;
	try {
		const hasProtocol = trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://');
		const hasWww = trimmedUrl.startsWith('www.');

		// For bare domains without protocol or www, check for valid domain.tld structure
		if (!hasProtocol && !hasWww) {
			// Domain must start with alphanumeric, can contain hyphens, then dot and 2+ char TLD
			const domainPattern = /^[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z]{2,}$/;
			if (!domainPattern.test(trimmedUrl)) return false;
		}

		const toParse = hasProtocol ? trimmedUrl : `https://${trimmedUrl}`;
		const parsed = new URL(toParse);

		// Additional check: hostname should have at least one dot (for domain.tld structure)
		// and the part before the first dot should not be empty
		const hostnameParts = parsed.hostname.split('.');
		if (hostnameParts.length < 2 || hostnameParts[0] === '') return false;

		return true;
	} catch {
		return false;
	}
};
